import { SplitTest } from '../api/opaApi';
import { OPA_FLAG, OPA_VARIABLE } from '../constants';
import { getActiveDecisionVariables, getSplitTestConfigs } from './splitTestService';

export interface DynamicScreenerSplitTest extends SplitTest {
  variables: {
    [OPA_VARIABLE.DYNAMIC_SCREENER_PROVIDERS]: string | null,
  }
}

export interface DynamicScreenerTestData {
  enabled    : boolean,
  providerIds: number[],
}

const parseProviderIds = (providerIds: string): number[] => {
  try {
    const ids = JSON.parse(providerIds);
    return Array.isArray(ids) ? ids.map(id => Number(id)) : [];
  } catch {
    return [];
  }
};

export const getDynamicScreenerTestData = (): DynamicScreenerTestData => {
  const testData = dynamicScreenerSplitTest();
  const isUserInTest = testData.enabled && testData.variables[OPA_VARIABLE.DYNAMIC_SCREENER_PROVIDERS] !== '';

  if (!isUserInTest) {
    return {
      enabled    : false,
      providerIds: [],
    };
  }

  const providerIds = parseProviderIds(testData.variables[OPA_VARIABLE.DYNAMIC_SCREENER_PROVIDERS] || '');

  if (providerIds.length === 0) {
    return {
      enabled    : false,
      providerIds: [],
    };
  }

  return {
    enabled: true,
    providerIds,
  };
};

export const dynamicScreenerSplitTest = (): DynamicScreenerSplitTest => {
  const testDecision = getSplitTestConfigs([OPA_FLAG.DYNAMIC_SCREENER]);
  const variables    = getActiveDecisionVariables(OPA_FLAG.DYNAMIC_SCREENER, testDecision);

  return {
    enabled: !!variables,
    variables: {
      [OPA_VARIABLE.DYNAMIC_SCREENER_PROVIDERS]: variables?.[OPA_VARIABLE.DYNAMIC_SCREENER_PROVIDERS],
    }
  };
};
